module.exports = __webpack_public_path__ + "img/photo-zhouzhe.55253dd6.png";